module.exports = __webpack_public_path__ + "static/img/dailyweekly.4be81f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dailyweekly.png
// module id = 3wbk
// module chunks = 1